import { Directive } from '@angular/core';

@Directive({
  selector: '[rv-draggable-handle]',
  standalone: false,
  host: {
    class: 'rv-draggable-handle',
    'aria-hidden': 'true',
  },
})
export class RvDraggableHandleDirective {}
